var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "380px",
    height: "380px",
    viewBox: "0 0 380 380",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(13.000000, 14.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 71.4425,
    y1: 177.0169,
    x2: 71.8055,
    y2: 176.6089,
    id: "Stroke-1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6129,
    y1: 165.9525,
    x2: 96.1019,
    y2: 166.0275,
    id: "Stroke-2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.5905,
    y1: 161.9671,
    x2: 98.9775,
    y2: 161.7471,
    id: "Stroke-3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.5905,
    y1: 165.9525,
    x2: 98.9775,
    y2: 165.7325,
    id: "Stroke-4",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.1017,
    y1: 162.0418,
    x2: 97.5907,
    y2: 161.9668,
    id: "Stroke-5",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.1017,
    y1: 166.0277,
    x2: 97.5907,
    y2: 165.9527,
    id: "Stroke-6",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.6129,
    y1: 161.9671,
    x2: 96.1019,
    y2: 162.0421,
    id: "Stroke-7",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2257,
    y1: 165.7327,
    x2: 92.0347,
    y2: 165.3827,
    id: "Stroke-8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2257,
    y1: 165.7327,
    x2: 94.6127,
    y2: 165.9527,
    id: "Stroke-9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2257,
    y1: 161.7474,
    x2: 92.0347,
    y2: 161.3974,
    id: "Stroke-10",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.2257,
    y1: 161.7474,
    x2: 94.6127,
    y2: 161.9674,
    id: "Stroke-11",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.9,
    y1: 161.3973,
    x2: 85.091,
    y2: 161.0473,
    id: "Stroke-12",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.0914,
    y1: 165.033,
    x2: 83.9004,
    y2: 165.383,
    id: "Stroke-13",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.9567,
    y1: 184.1126,
    x2: 23.4017,
    y2: 188.5346,
    id: "Stroke-14",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.9,
    y1: 161.3973,
    x2: 23.402,
    y2: 184.5493,
    id: "Stroke-15",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.1915,
    y1: 178.6653,
    x2: 83.8995,
    y2: 165.3823,
    id: "Stroke-16",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.1915,
    y1: 176.6722,
    x2: 35.8015,
    y2: 181.7972,
    id: "Stroke-17",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 184.1302,
    x2: 137.3756,
    y2: 175.9592,
    id: "Stroke-18",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.3761,
    y1: 177.9515,
    x2: 158.7291,
    y2: 186.1235,
    id: "Stroke-19",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9488,
    y1: 109.8055,
    x2: 158.7288,
    y2: 184.1305,
    id: "Stroke-20",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 119.3856,
    x2: 158.7287,
    y2: 186.1026,
    id: "Stroke-21",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9488,
    y1: 111.7781,
    x2: 333.1218,
    y2: 119.3851,
    id: "Stroke-22",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.6891,
    y1: 258.6907,
    x2: 311.2371,
    y2: 211.0277,
    id: "Stroke-23",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.4889,
    y1: 253.9251,
    x2: 138.9019,
    y2: 267.5431,
    id: "Stroke-24",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.9015,
    y1: 239.6575,
    x2: 138.9015,
    y2: 267.5435,
    id: "Stroke-25",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.9015,
    y1: 209.1028,
    x2: 138.9015,
    y2: 237.6528,
    id: "Stroke-26",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.9015,
    y1: 178.5355,
    x2: 138.9015,
    y2: 207.0975,
    id: "Stroke-27",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 133.8089,
    x2: 119.5826,
    y2: 118.8289,
    id: "Stroke-28",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.4234,
    y1: 60.0677,
    x2: 157.2034,
    y2: 134.3927,
    id: "Stroke-29",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.4889,
    y1: 239.6458,
    x2: 174.4889,
    y2: 253.9248,
    id: "Stroke-30",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.4889,
    y1: 209.0902,
    x2: 174.4889,
    y2: 224.0322,
    id: "Stroke-31",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.6901,
    y1: 258.6976,
    x2: 186.6901,
    y2: 234.9726,
    id: "Stroke-32",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 277.1243,
    x2: 352.9486,
    y2: 202.7993,
    id: "Stroke-33",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 170.5413,
    x2: 41.195,
    y2: 163.3423,
    id: "Stroke-34",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.6754,
    y1: 226.8187,
    x2: 41.4494,
    y2: 224.6087,
    id: "Stroke-35",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-36",
    strokeWidth: 0.5,
    points: "23.4034 272.6976 41.4494 265.7916 41.4494 224.6086 39.9244 224.0256 35.7994 225.6036"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-37",
    strokeWidth: 0.5,
    points: "41.7042 265.6946 41.7042 224.5116 47.9652 222.1156"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.1788,
    y1: 223.928,
    x2: 41.7038,
    y2: 224.512,
    id: "Stroke-38",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-39",
    strokeWidth: 0.5,
    points: "45.4122 221.9251 40.1792 223.9281 40.1792 224.1221"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-40",
    strokeWidth: 0.5,
    points: "41.4508 265.598 41.7038 265.695 59.7518 258.788 59.7518 217.799"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8029,
    y1: 243.262,
    x2: 152.6119,
    y2: 242.911,
    id: "Stroke-41",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.6901,
    y1: 258.6917,
    x2: 174.4891,
    y2: 254.0227,
    id: "Stroke-42",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.8483,
    y1: 141.1385,
    x2: 319.3793,
    y2: 151.6505,
    id: "Stroke-43",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.0953,
    y1: 140.4246,
    x2: 347.7623,
    y2: 140.6826,
    id: "Stroke-44",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.3766,
    y1: 98.2425,
    x2: 173.3766,
    y2: 74.6805,
    id: "Stroke-45",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.6759,
    y1: 183.6429,
    x2: 41.4499,
    y2: 181.4329,
    id: "Stroke-46",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-47",
    strokeWidth: 0.5,
    points: "23.4025 229.5228 41.4495 222.6168 41.4495 181.4328 39.9245 180.8498 35.7995 182.4278"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4034,
    y1: 170.1517,
    x2: 41.1964,
    y2: 163.3417,
    id: "Stroke-48",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1676,
    y1: 245.4739,
    x2: 156.6786,
    y2: 245.5489,
    id: "Stroke-49",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.7462,
    y1: 242.9114,
    x2: 188.2152,
    y2: 232.3994,
    id: "Stroke-50",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.7462,
    y1: 244.9046,
    x2: 188.2152,
    y2: 234.3926,
    id: "Stroke-51",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 229.7435,
    x2: 188.7115,
    y2: 229.5035,
    id: "Stroke-52",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8854,
    y1: 237.6585,
    x2: 152.6124,
    y2: 242.9115,
    id: "Stroke-53",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8854,
    y1: 239.6517,
    x2: 152.6124,
    y2: 244.9047,
    id: "Stroke-54",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 229.7161,
    x2: 23.402,
    y2: 159.4871,
    id: "Stroke-55",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4503,
    y1: 276.8597,
    x2: 23.4503,
    y2: 292.8017,
    id: "Stroke-56",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.7462,
    y1: 212.3568,
    x2: 188.2152,
    y2: 201.8448,
    id: "Stroke-57",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 199.1878,
    x2: 188.7115,
    y2: 198.9488,
    id: "Stroke-58",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8854,
    y1: 207.1038,
    x2: 152.6124,
    y2: 212.3568,
    id: "Stroke-59",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8854,
    y1: 209.097,
    x2: 152.6124,
    y2: 214.349,
    id: "Stroke-60",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 178.9388,
    x2: 346.8487,
    y2: 173.6858,
    id: "Stroke-61",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.3795,
    y1: 184.1986,
    x2: 333.1215,
    y2: 178.9386,
    id: "Stroke-62",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7623,
    y1: 171.2376,
    x2: 348.0953,
    y2: 170.9796,
    id: "Stroke-63",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.5055,
    y1: 83.6512,
    x2: 211.5055,
    y2: 10.9362,
    id: "Stroke-64",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.0153,
    y1: 8.3655,
    x2: 192.6793,
    y2: 0.5835,
    id: "Stroke-65",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.5407,
    y1: 7.782,
    x2: 213.0157,
    y2: 8.365,
    id: "Stroke-66",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.0153,
    y1: 83.0736,
    x2: 213.0153,
    y2: 8.3656,
    id: "Stroke-67",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-68",
    strokeWidth: 2,
    points: "214.5407 7.782 194.2047 -2.84217094e-14 192.6797 0.583"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-70",
    strokeWidth: 0.5,
    points: "35.6749 125.1898 35.4139 125.4318 34.9569 125.6598 23.3859 130.0868"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-71",
    strokeWidth: 0.5,
    points: "211.4899 58.1028 200.0249 62.4908 199.4289 62.6648 198.7999 62.7658"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7985,
    y1: 125.1419,
    x2: 35.7985,
    y2: 126.8739,
    id: "Stroke-72",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.5328,
    y1: 110.3196,
    x2: 74.5328,
    y2: 112.0506,
    id: "Stroke-73",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.2638,
    y1: 96.2635,
    x2: 111.2638,
    y2: 97.9945,
    id: "Stroke-74",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.5031,
    y1: 82.0125,
    x2: 148.5031,
    y2: 83.7435,
    id: "Stroke-75",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.6324,
    y1: 67.4212,
    x2: 186.6324,
    y2: 69.1522,
    id: "Stroke-76",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.4899,
    y1: 253.6644,
    x2: 80.4899,
    y2: 249.6794,
    id: "Stroke-77",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-78",
    strokeWidth: 0.5,
    points: "99.3829 100.8099 117.4299 93.9039 117.4299 48.9299"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.1715,
    y1: 64.9188,
    x2: 193.1715,
    y2: 19.9438,
    id: "Stroke-79",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-80",
    strokeWidth: 0.5,
    points: "192.9176 64.8211 193.1716 64.9191 211.2196 58.0121 211.2196 13.0381"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4425,
    y1: 200.4388,
    x2: 71.8055,
    y2: 200.8468,
    id: "Stroke-81",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.0309,
    y1: 83.0672,
    x2: 213.0309,
    y2: 10.3522,
    id: "Stroke-82",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-83",
    strokeWidth: 0.5,
    points: "1.5411 73.7288 21.8771 81.5108 21.8771 83.5038"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.8771,
    y1: 81.5111,
    x2: 213.0151,
    y2: 8.3651,
    id: "Stroke-84",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-85",
    strokeWidth: 0.5,
    points: "213.0475 10.346 21.8775 83.504 21.8605 83.497"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-86",
    strokeWidth: 0.5,
    points: "192.7115 0.5711 213.0475 8.3531 213.0475 10.3461"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-87",
    strokeWidth: 2,
    points: "1.5411 73.741 1.5411 73.729 192.6781 0.584"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-88",
    strokeWidth: 0.5,
    points: "137.5114 86.2191 155.1814 79.4571 155.1814 34.4831"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.4357,
    y1: 79.3597,
    x2: 155.4357,
    y2: 34.3847,
    id: "Stroke-89",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-90",
    strokeWidth: 0.5,
    points: "155.1818 79.2625 155.4358 79.3595 173.1068 72.5975 173.1068 27.6235"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 170.5413,
    x2: 60.006,
    y2: 145.4813,
    id: "Stroke-91",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.5314,
    y1: 117.4822,
    x2: 61.5314,
    y2: 169.9582,
    id: "Stroke-92",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 159.4876,
    x2: 60.006,
    y2: 145.4796,
    id: "Stroke-93",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-94",
    strokeWidth: 0.5,
    points: "174.8873 71.9158 192.9173 65.0158 192.9173 20.0418"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4425,
    y1: 178.7269,
    x2: 71.8055,
    y2: 179.1349,
    id: "Stroke-95",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.4234,
    y1: 60.0677,
    x2: 312.2774,
    y2: 45.0877,
    id: "Stroke-96",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.7525,
    y1: 45.6712,
    x2: 312.2775,
    y2: 45.0872,
    id: "Stroke-97",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 275.1312,
    x2: 137.3756,
    y2: 266.9602,
    id: "Stroke-98",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 275.1312,
    x2: 158.7286,
    y2: 277.1242,
    id: "Stroke-99",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-100",
    strokeWidth: 0.5,
    points: "21.861 81.5174 20.336 82.1004 -6.21724894e-14 74.3184"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.3361,
    y1: 297.9788,
    x2: 20.3361,
    y2: 82.1008,
    id: "Stroke-102",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-103",
    strokeWidth: 0.5,
    points: "21.861 297.3958 21.861 81.5178 1.526 73.7348"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-104",
    strokeWidth: 2,
    points: "1.5255 73.7352 0.0005 74.3182 0.0005 290.1962 20.3365 297.9792 21.8605 297.3962"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 148.3841,
    x2: 346.8487,
    y2: 143.1311,
    id: "Stroke-106",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 319.3795,
    y1: 153.6434,
    x2: 333.1215,
    y2: 148.3844,
    id: "Stroke-107",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.5114,
    y1: 86.4134,
    x2: 137.5114,
    y2: 41.2454,
    id: "Stroke-108",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.986,
    y1: 41.8284,
    x2: 135.986,
    y2: 86.9974,
    id: "Stroke-109",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.8854,
    y1: 72.1107,
    x2: 174.8854,
    y2: 26.9427,
    id: "Stroke-110",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.6881,
    y1: 122.889,
    x2: 41.6881,
    y2: 77.915,
    id: "Stroke-111",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-112",
    strokeWidth: 0.5,
    points: "41.4347 122.7918 41.6877 122.8888 59.7357 115.9818 59.7357 71.0078"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-113",
    strokeWidth: 0.5,
    points: "23.4034 129.8861 41.4334 122.9861 41.4334 78.0111"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 84.9129,
    x2: 211.49,
    y2: 12.9349,
    id: "Stroke-114",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.8771,
    y1: 297.389,
    x2: 21.8771,
    y2: 83.504,
    id: "Stroke-115",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 157.4949,
    x2: 23.402,
    y2: 84.9139,
    id: "Stroke-116",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 296.806,
    x2: 23.402,
    y2: 231.71,
    id: "Stroke-117",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.9567,
    y1: 127.6522,
    x2: 23.3857,
    y2: 132.0802,
    id: "Stroke-118",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1241,
    y1: 122.2049,
    x2: 35.8001,
    y2: 125.7729,
    id: "Stroke-119",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6906,
    y1: 112.8294,
    x2: 49.1916,
    y2: 122.2044,
    id: "Stroke-120",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.8287,
    y1: 79.0745,
    x2: 148.5027,
    y2: 82.6435,
    id: "Stroke-121",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.7897,
    y1: 69.9305,
    x2: 161.8957,
    y2: 79.0745,
    id: "Stroke-122",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.9576,
    y1: 64.4832,
    x2: 186.6326,
    y2: 68.0512,
    id: "Stroke-123",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.902,
    y1: 74.0975,
    x2: 174.902,
    y2: 97.6585,
    id: "Stroke-124",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5958,
    y1: 178.8402,
    x2: 47.9018,
    y2: 178.9502,
    id: "Stroke-125",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.444,
    y1: 178.4652,
    x2: 45.72,
    y2: 178.8402,
    id: "Stroke-126",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7985,
    y1: 224.7786,
    x2: 35.7985,
    y2: 226.5096,
    id: "Stroke-127",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.5314,
    y1: 258.3021,
    x2: 61.5314,
    y2: 173.9431,
    id: "Stroke-128",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 217.7025,
    x2: 60.006,
    y2: 258.8855,
    id: "Stroke-129",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 174.5267,
    x2: 60.006,
    y2: 215.7097,
    id: "Stroke-130",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.1686,
    y1: 161.3973,
    x2: 118.0586,
    y2: 154.5513,
    id: "Stroke-131",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.4615,
    y1: 201.1302,
    x2: 189.1285,
    y2: 201.3892,
    id: "Stroke-132",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.9015,
    y1: 207.098,
    x2: 174.4885,
    y2: 193.479,
    id: "Stroke-133",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.6881,
    y1: 228.7064,
    x2: 174.4891,
    y2: 224.0374,
    id: "Stroke-134",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.2155,
    y1: 229.2903,
    x2: 186.6885,
    y2: 228.7063,
    id: "Stroke-135",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.7028,
    y1: 198.1146,
    x2: 174.4888,
    y2: 193.4406,
    id: "Stroke-136",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.2155,
    y1: 198.6937,
    x2: 186.7025,
    y2: 198.1147,
    id: "Stroke-137",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.8483,
    y1: 171.6937,
    x2: 319.3793,
    y2: 182.2057,
    id: "Stroke-138",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 143.4871,
    x2: 23.402,
    y2: 157.4951,
    id: "Stroke-139",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 143.4871,
    x2: 41.195,
    y2: 136.2891,
    id: "Stroke-140",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.0436,
    y1: 84.5931,
    x2: 192.6636,
    y2: 78.3241,
    id: "Stroke-141",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.3605,
    y1: 27.5262,
    x2: 173.3605,
    y2: 72.6942,
    id: "Stroke-142",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.2447,
    y1: 211.0042,
    x2: 311.2447,
    y2: 127.7572,
    id: "Stroke-143",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.2155,
    y1: 229.2864,
    x2: 188.2155,
    y2: 203.8374,
    id: "Stroke-144",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.5407,
    y1: 82.5106,
    x2: 119.5827,
    y2: 118.8286,
    id: "Stroke-145",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.7525,
    y1: 45.6712,
    x2: 214.5405,
    y2: 82.5102,
    id: "Stroke-146",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.4889,
    y1: 224.0345,
    x2: 138.8849,
    y2: 237.6585,
    id: "Stroke-147",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 277.1243,
    x2: 158.7286,
    y2: 350.8543,
    id: "Stroke-148",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.2032,
    y1: 183.5462,
    x2: 157.2032,
    y2: 134.3932,
    id: "Stroke-150",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9488,
    y1: 109.8055,
    x2: 352.9488,
    y2: 60.6515,
    id: "Stroke-151",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 134.9764,
    x2: 352.9486,
    y2: 60.6514,
    id: "Stroke-152",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 134.9764,
    x2: 158.7286,
    y2: 184.1304,
    id: "Stroke-153",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.3761,
    y1: 175.9593,
    x2: 137.3761,
    y2: 268.9523,
    id: "Stroke-154",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0577,
    y1: 247.3528,
    x2: 118.0577,
    y2: 335.2908,
    id: "Stroke-155",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0573,
    y1: 119.4119,
    x2: 118.0573,
    y2: 247.3529,
    id: "Stroke-156",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0573,
    y1: 119.4119,
    x2: 157.2033,
    y2: 134.3929,
    id: "Stroke-157",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.6901,
    y1: 198.1487,
    x2: 186.6901,
    y2: 175.4217,
    id: "Stroke-158",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.6901,
    y1: 228.7025,
    x2: 186.6901,
    y2: 204.4215,
    id: "Stroke-159",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4425,
    y1: 221.9017,
    x2: 71.8055,
    y2: 222.3107,
    id: "Stroke-160",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0587,
    y1: 203.721,
    x2: 73.6757,
    y2: 220.705,
    id: "Stroke-161",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7985,
    y1: 181.7972,
    x2: 35.7985,
    y2: 183.3342,
    id: "Stroke-162",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.4137,
    y1: 183.8851,
    x2: 35.7007,
    y2: 183.6191,
    id: "Stroke-163",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.9567,
    y1: 225.2952,
    x2: 23.3857,
    y2: 229.7232,
    id: "Stroke-164",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.9567,
    y1: 227.2884,
    x2: 23.3857,
    y2: 231.7164,
    id: "Stroke-165",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7008,
    y1: 226.7952,
    x2: 35.4138,
    y2: 227.0612,
    id: "Stroke-166",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5958,
    y1: 222.0159,
    x2: 47.9018,
    y2: 222.1249,
    id: "Stroke-167",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7511,
    y1: 215.6116,
    x2: 60.0061,
    y2: 215.7096,
    id: "Stroke-168",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.1984,
    y1: 221.5687,
    x2: 45.7194,
    y2: 222.0157,
    id: "Stroke-169",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.1915,
    y1: 221.8411,
    x2: 60.0055,
    y2: 217.7021,
    id: "Stroke-170",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-171",
    strokeWidth: 0.5,
    points: "41.7042 222.5189 41.7042 181.3359 47.9652 178.9399"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.1788,
    y1: 180.7523,
    x2: 41.7038,
    y2: 181.3363,
    id: "Stroke-172",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.7516,
    y1: 215.6097,
    x2: 59.7516,
    y2: 174.6247,
    id: "Stroke-173",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-174",
    strokeWidth: 0.5,
    points: "41.4498 222.4212 41.7038 222.5192 59.7518 215.6122"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-175",
    strokeWidth: 0.5,
    points: "45.4122 178.7493 40.1792 180.7523 40.1792 180.9463"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.2155,
    y1: 203.8372,
    x2: 160.7465,
    y2: 214.3492,
    id: "Stroke-176",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.5153,
    y1: 115.4959,
    x2: 61.5153,
    y2: 70.3279,
    id: "Stroke-177",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.9899,
    y1: 70.911,
    x2: 59.9899,
    y2: 116.079,
    id: "Stroke-178",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.3824,
    y1: 101.0047,
    x2: 99.3824,
    y2: 55.8367,
    id: "Stroke-179",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.8571,
    y1: 56.4202,
    x2: 97.8571,
    y2: 101.5882,
    id: "Stroke-180",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5553,
    y1: 108.3978,
    x2: 79.5553,
    y2: 63.4238,
    id: "Stroke-181",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-182",
    strokeWidth: 0.5,
    points: "79.3014 108.3006 79.5554 108.3976 97.6024 101.4906 97.6024 56.5176"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.5382,
    y1: 269.5882,
    x2: 80.5382,
    y2: 261.7112,
    id: "Stroke-183",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-184",
    strokeWidth: 0.5,
    points: "61.5167 115.3006 79.3007 108.4946 79.3007 63.5216"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.6842,
    y1: 93.8065,
    x2: 117.6842,
    y2: 48.8325,
    id: "Stroke-185",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-186",
    strokeWidth: 0.5,
    points: "117.4303 93.7093 117.6843 93.8063 135.7323 86.8993 135.7323 41.9253"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.3341,
    y1: 251.3294,
    x2: 78.7071,
    y2: 251.6884,
    id: "Stroke-187",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.5079,
    y1: 244.7152,
    x2: 72.1349,
    y2: 245.0742,
    id: "Stroke-188",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.6461,
    y1: 243.9183,
    x2: 71.0091,
    y2: 244.3273,
    id: "Stroke-189",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 272.8929,
    x2: 77.963,
    y2: 252.0129,
    id: "Stroke-190",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.963,
    y1: 255.9993,
    x2: 23.402,
    y2: 276.8783,
    id: "Stroke-191",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4425,
    y1: 177.0169,
    x2: 71.2225,
    y2: 177.4409,
    id: "Stroke-192",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 145.4813,
    x2: 60.006,
    y2: 145.4793,
    id: "Stroke-193",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1241,
    y1: 121.574,
    x2: 45.1241,
    y2: 122.205,
    id: "Stroke-194",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-195",
    strokeWidth: 0.5,
    points: "74.4093 110.3665 74.1473 110.6085 73.6903 110.8365 61.5153 115.4955"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-196",
    strokeWidth: 0.5,
    points: "59.9899 116.0794 49.1919 120.2114 48.5959 120.3874 47.9649 120.4874"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.858,
    y1: 106.7508,
    x2: 83.858,
    y2: 107.3818,
    id: "Stroke-197",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.5895,
    y1: 92.6942,
    x2: 120.5895,
    y2: 93.3252,
    id: "Stroke-198",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.8287,
    y1: 78.4437,
    x2: 157.8287,
    y2: 79.0747,
    id: "Stroke-199",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-200",
    strokeWidth: 0.5,
    points: "186.5084 67.4686 186.2464 67.7096 185.7894 67.9376 174.8854 72.1106"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-201",
    strokeWidth: 0.5,
    points: "173.3595 72.6951 161.8955 77.0821 161.3005 77.2571 160.6695 77.3571"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.9576,
    y1: 63.8514,
    x2: 195.9576,
    y2: 64.4834,
    id: "Stroke-202",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1954,
    y1: 152.678,
    x2: 41.1954,
    y2: 163.343,
    id: "Stroke-203",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.5485,
    y1: 165.9993,
    x2: 61.5315,
    y2: 179.0173,
    id: "Stroke-204",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.5319,
    y1: 155.5604,
    x2: 118.0589,
    y2: 133.9284,
    id: "Stroke-205",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.5065,
    y1: 58.0965,
    x2: 211.4895,
    y2: 58.1025,
    id: "Stroke-206",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.6949,
    y1: 78.3367,
    x2: 192.6949,
    y2: 65.7317,
    id: "Stroke-207",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.4899,
    y1: 253.3655,
    x2: 80.5379,
    y2: 261.7115,
    id: "Stroke-208",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0587,
    y1: 243.3675,
    x2: 80.5387,
    y2: 257.7245,
    id: "Stroke-209",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-210",
    strokeWidth: 0.5,
    points: "111.1407 96.3104 110.8787 96.5524 110.4217 96.7804 99.3827 101.0044"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-211",
    strokeWidth: 0.5,
    points: "97.8585 101.5882 87.9255 105.3892 87.3295 105.5642 86.6995 105.6642"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-212",
    strokeWidth: 0.5,
    points: "148.3795 82.0594 148.1185 82.3014 147.6605 82.5294 137.5115 86.4134"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-213",
    strokeWidth: 0.5,
    points: "135.9855 86.9974 124.6565 91.3324 124.0605 91.5074 123.4305 91.6074"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.4401,
    y1: 98.6009,
    x2: 172.4411,
    y2: 98.6009,
    id: "Stroke-214",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.6749,
    y1: 224.8265,
    x2: 35.4139,
    y2: 225.0675,
    id: "Stroke-215",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.4889,
    y1: 180.0911,
    x2: 174.4889,
    y2: 193.4791,
    id: "Stroke-216",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1954,
    y1: 123.7083,
    x2: 41.1954,
    y2: 136.2873,
    id: "Stroke-217",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.566,
    y1: 80.3231,
    x2: 154.566,
    y2: 105.4411,
    id: "Stroke-218",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.5739,
    y1: 224.637,
    x2: 201.5729,
    y2: 224.637,
    id: "Stroke-219",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.3859,
    y1: 130.0872,
    x2: 23.3859,
    y2: 132.0802,
    id: "Stroke-220",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.5343,
    y1: 105.4529,
    x2: 154.5343,
    y2: 80.3349,
    id: "Stroke-221",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.9015,
    y1: 207.098,
    x2: 138.8855,
    y2: 207.104,
    id: "Stroke-222",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 184.1302,
    x2: 158.7286,
    y2: 186.1232,
    id: "Stroke-223",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9488,
    y1: 109.8055,
    x2: 352.9488,
    y2: 111.7975,
    id: "Stroke-224",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 132.7728,
    x2: 311.2457,
    y2: 141.1448,
    id: "Stroke-225",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0573,
    y1: 119.4119,
    x2: 119.5823,
    y2: 118.8289,
    id: "Stroke-226",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.4234,
    y1: 60.0677,
    x2: 352.9484,
    y2: 60.6507,
    id: "Stroke-227",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 134.9764,
    x2: 157.2036,
    y2: 134.3934,
    id: "Stroke-228",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9488,
    y1: 264.5735,
    x2: 352.9488,
    y2: 202.7995,
    id: "Stroke-229",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9488,
    y1: 276.5296,
    x2: 158.7288,
    y2: 350.8546,
    id: "Stroke-230",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 231.9446,
    x2: 189.4615,
    y2: 231.6856,
    id: "Stroke-232",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1676,
    y1: 243.4818,
    x2: 156.6786,
    y2: 243.5568,
    id: "Stroke-233",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 231.9446,
    x2: 188.7115,
    y2: 232.1836,
    id: "Stroke-234",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.9,
    y1: 230.8441,
    x2: 189.85,
    y2: 231.1311,
    id: "Stroke-235",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.8502,
    y1: 230.556,
    x2: 189.9002,
    y2: 230.844,
    id: "Stroke-236",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 229.7435,
    x2: 189.4615,
    y2: 230.0015,
    id: "Stroke-237",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.2155,
    y1: 229.2874,
    x2: 188.7115,
    y2: 229.5034,
    id: "Stroke-238",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.8004,
    y1: 152.22,
    x2: 315.3124,
    y2: 152.295,
    id: "Stroke-239",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3443,
    y1: 140.9222,
    x2: 346.8483,
    y2: 141.1382,
    id: "Stroke-240",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.3365,
    y1: 140.1517,
    x2: 348.0955,
    y2: 140.4247,
    id: "Stroke-241",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 139.8694,
    x2: 348.337,
    y2: 140.1514,
    id: "Stroke-242",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 139.2947,
    x2: 348.533,
    y2: 139.5827,
    id: "Stroke-243",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.3365,
    y1: 139.0125,
    x2: 348.4835,
    y2: 139.2945,
    id: "Stroke-244",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 258.8851,
    x2: 59.75,
    y2: 258.7871,
    id: "Stroke-245",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.1686,
    y1: 161.3973,
    x2: 98.9776,
    y2: 161.7473,
    id: "Stroke-246",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.9,
    y1: 232.8362,
    x2: 189.9,
    y2: 230.8442,
    id: "Stroke-247",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.1901,
    y1: 243.4818,
    x2: 156.6791,
    y2: 243.5568,
    id: "Stroke-248",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.1901,
    y1: 245.4739,
    x2: 156.6791,
    y2: 245.5489,
    id: "Stroke-249",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8029,
    y1: 243.262,
    x2: 155.1899,
    y2: 243.482,
    id: "Stroke-250",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8029,
    y1: 245.2542,
    x2: 155.1899,
    y2: 245.4742,
    id: "Stroke-251",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.6119,
    y1: 244.9046,
    x2: 153.8029,
    y2: 245.2546,
    id: "Stroke-252",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.7115,
    y1: 234.1761,
    x2: 188.2155,
    y2: 234.3931,
    id: "Stroke-253",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.7037,
    y1: 230.2737,
    x2: 189.4617,
    y2: 230.0017,
    id: "Stroke-254",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.8502,
    y1: 230.556,
    x2: 189.7042,
    y2: 230.274,
    id: "Stroke-255",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.8502,
    y1: 233.1234,
    x2: 189.9002,
    y2: 232.8364,
    id: "Stroke-256",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.7037,
    y1: 231.4134,
    x2: 189.8497,
    y2: 231.1314,
    id: "Stroke-257",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.7037,
    y1: 233.4056,
    x2: 189.8497,
    y2: 233.1236,
    id: "Stroke-258",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.4615,
    y1: 231.6859,
    x2: 189.7035,
    y2: 231.4139,
    id: "Stroke-259",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.4615,
    y1: 233.679,
    x2: 189.7035,
    y2: 233.406,
    id: "Stroke-260",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 233.9368,
    x2: 188.7115,
    y2: 234.1758,
    id: "Stroke-261",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 233.9368,
    x2: 189.4615,
    y2: 233.6788,
    id: "Stroke-262",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.7115,
    y1: 232.1839,
    x2: 188.2155,
    y2: 232.3999,
    id: "Stroke-263",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5548,
    y1: 243.262,
    x2: 160.7458,
    y2: 242.911,
    id: "Stroke-264",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5548,
    y1: 245.2542,
    x2: 158.1678,
    y2: 245.4742,
    id: "Stroke-265",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5548,
    y1: 245.2542,
    x2: 160.7458,
    y2: 244.9042,
    id: "Stroke-266",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1676,
    y1: 243.4818,
    x2: 159.5546,
    y2: 243.2618,
    id: "Stroke-267",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4503,
    y1: 292.8021,
    x2: 23.4033,
    y2: 292.7831,
    id: "Stroke-268",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.755,
    y1: 255.6556,
    x2: 78.011,
    y2: 255.9806,
    id: "Stroke-269",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.2443,
    y1: 254.5003,
    x2: 79.8813,
    y2: 254.9093,
    id: "Stroke-270",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.464,
    y1: 254.0765,
    x2: 80.244,
    y2: 254.5005,
    id: "Stroke-271",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1832,
    y1: 245.0218,
    x2: 72.1142,
    y2: 245.0608,
    id: "Stroke-272",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9269,
    y1: 244.6966,
    x2: 72.1829,
    y2: 245.0216,
    id: "Stroke-273",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.9,
    y1: 202.2816,
    x2: 189.9,
    y2: 200.2886,
    id: "Stroke-274",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.1901,
    y1: 214.9193,
    x2: 156.6791,
    y2: 214.9943,
    id: "Stroke-275",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8029,
    y1: 212.7064,
    x2: 155.1899,
    y2: 212.9264,
    id: "Stroke-276",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8029,
    y1: 214.6995,
    x2: 155.1899,
    y2: 214.9195,
    id: "Stroke-277",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.7115,
    y1: 203.6214,
    x2: 188.2155,
    y2: 203.8374,
    id: "Stroke-278",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.8502,
    y1: 200.0013,
    x2: 189.7042,
    y2: 199.7193,
    id: "Stroke-279",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.8502,
    y1: 202.5687,
    x2: 189.9002,
    y2: 202.2817,
    id: "Stroke-280",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.4615,
    y1: 201.1302,
    x2: 189.7035,
    y2: 200.8582,
    id: "Stroke-281",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 203.3821,
    x2: 188.7115,
    y2: 203.6211,
    id: "Stroke-282",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8854,
    y1: 209.097,
    x2: 138.8854,
    y2: 207.104,
    id: "Stroke-283",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5548,
    y1: 214.6995,
    x2: 160.7458,
    y2: 214.3485,
    id: "Stroke-284",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1676,
    y1: 212.9261,
    x2: 156.6786,
    y2: 213.0011,
    id: "Stroke-285",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.5328,
    y1: 172.1302,
    x2: 348.5328,
    y2: 170.1372,
    id: "Stroke-286",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.4361,
    y1: 184.5482,
    x2: 313.8241,
    y2: 184.7682,
    id: "Stroke-287",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.2447,
    y1: 182.2054,
    x2: 312.4357,
    y2: 182.5554,
    id: "Stroke-288",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.2447,
    y1: 184.1986,
    x2: 312.4357,
    y2: 184.5486,
    id: "Stroke-289",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 170.4246,
    x2: 348.533,
    y2: 170.1366,
    id: "Stroke-290",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3443,
    y1: 173.47,
    x2: 346.8483,
    y2: 173.686,
    id: "Stroke-291",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.0953,
    y1: 169.2947,
    x2: 347.7623,
    y2: 169.0367,
    id: "Stroke-292",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 169.8499,
    x2: 348.337,
    y2: 169.5679,
    id: "Stroke-293",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 163.3279,
    x2: 346.8487,
    y2: 168.5809,
    id: "Stroke-294",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 172.4173,
    x2: 348.533,
    y2: 172.1303,
    id: "Stroke-295",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.3365,
    y1: 170.7069,
    x2: 348.4835,
    y2: 170.4249,
    id: "Stroke-296",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.3365,
    y1: 172.6995,
    x2: 348.4835,
    y2: 172.4175,
    id: "Stroke-297",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.0953,
    y1: 172.972,
    x2: 348.3363,
    y2: 172.7,
    id: "Stroke-298",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7623,
    y1: 173.2308,
    x2: 347.3443,
    y2: 173.4698,
    id: "Stroke-299",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7623,
    y1: 173.2308,
    x2: 348.0953,
    y2: 172.9718,
    id: "Stroke-300",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3443,
    y1: 171.4769,
    x2: 346.8483,
    y2: 171.6939,
    id: "Stroke-301",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3443,
    y1: 171.4769,
    x2: 347.7623,
    y2: 171.2379,
    id: "Stroke-302",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.3121,
    y1: 184.8431,
    x2: 313.8241,
    y2: 184.7681,
    id: "Stroke-303",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.8004,
    y1: 184.7679,
    x2: 315.3124,
    y2: 184.8429,
    id: "Stroke-304",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.1881,
    y1: 182.555,
    x2: 319.3791,
    y2: 182.205,
    id: "Stroke-305",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.1881,
    y1: 184.5482,
    x2: 319.3791,
    y2: 184.1982,
    id: "Stroke-306",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.1881,
    y1: 184.5482,
    x2: 316.8001,
    y2: 184.7682,
    id: "Stroke-307",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.8004,
    y1: 182.7757,
    x2: 315.3124,
    y2: 182.8497,
    id: "Stroke-308",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.8004,
    y1: 182.7757,
    x2: 318.1884,
    y2: 182.5547,
    id: "Stroke-309",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.8785,
    y1: 98.5452,
    x2: 111.1655,
    y2: 98.2792,
    id: "Stroke-310",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.4215,
    y1: 98.7728,
    x2: 110.8785,
    y2: 98.5448,
    id: "Stroke-311",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9254,
    y1: 107.3821,
    x2: 110.4214,
    y2: 98.7731,
    id: "Stroke-312",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.3297,
    y1: 107.5565,
    x2: 87.9257,
    y2: 107.3825,
    id: "Stroke-313",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.1476,
    y1: 107.6668,
    x2: 85.8916,
    y2: 107.7048,
    id: "Stroke-314",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.4537,
    y1: 107.5565,
    x2: 85.1477,
    y2: 107.6665,
    id: "Stroke-315",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.858,
    y1: 107.3821,
    x2: 84.454,
    y2: 107.5561,
    id: "Stroke-316",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.4347,
    y1: 112.3358,
    x2: 74.5327,
    y2: 112.0508,
    id: "Stroke-317",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.4899,
    y1: 60.096,
    x2: 200.0249,
    y2: 64.483,
    id: "Stroke-318",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.2467,
    y1: 64.7679,
    x2: 197.9917,
    y2: 64.8059,
    id: "Stroke-319",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.5348,
    y1: 69.4373,
    x2: 186.6328,
    y2: 69.1523,
    id: "Stroke-320",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.7897,
    y1: 69.9305,
    x2: 186.2467,
    y2: 69.7025,
    id: "Stroke-321",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.6066,
    y1: 79.3597,
    x2: 161.3006,
    y2: 79.2497,
    id: "Stroke-322",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.8287,
    y1: 79.0745,
    x2: 158.4247,
    y2: 79.2495,
    id: "Stroke-323",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.4054,
    y1: 84.0286,
    x2: 148.5034,
    y2: 83.7436,
    id: "Stroke-324",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.6564,
    y1: 93.3255,
    x2: 124.0604,
    y2: 93.5005,
    id: "Stroke-325",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.4899,
    y1: 58.1028,
    x2: 211.4899,
    y2: 60.0958,
    id: "Stroke-326",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.0309,
    y1: 57.5135,
    x2: 213.0159,
    y2: 57.5075,
    id: "Stroke-327",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 228.5169,
    x2: 80.6293,
    y2: 228.9259,
    id: "Stroke-328",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 215.7093,
    x2: 49.192,
    y2: 219.8483,
    id: "Stroke-329",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 132.7728,
    x2: 333.1217,
    y2: 119.3858,
    id: "Stroke-330",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.2155,
    y1: 258.1048,
    x2: 188.2155,
    y2: 234.3928,
    id: "Stroke-331",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.7525,
    y1: 45.6712,
    x2: 349.8985,
    y2: 60.6512,
    id: "Stroke-332",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8854,
    y1: 239.6517,
    x2: 138.8854,
    y2: 237.6587,
    id: "Stroke-333",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4425,
    y1: 220.1927,
    x2: 71.2225,
    y2: 220.6167,
    id: "Stroke-334",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 217.7025,
    x2: 60.006,
    y2: 215.7095,
    id: "Stroke-335",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.8854,
    y1: 209.097,
    x2: 138.9014,
    y2: 209.09,
    id: "Stroke-336",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.382,
    y1: 271.2386,
    x2: 78.755,
    y2: 271.5976,
    id: "Stroke-337",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0577,
    y1: 179.097,
    x2: 61.5317,
    y2: 200.729,
    id: "Stroke-338",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0582,
    y1: 200.5609,
    x2: 61.5312,
    y2: 222.1929,
    id: "Stroke-339",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9269,
    y1: 244.6966,
    x2: 118.0579,
    y2: 227.4256,
    id: "Stroke-340",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.5382,
    y1: 261.7112,
    x2: 118.0582,
    y2: 247.3532,
    id: "Stroke-341",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0573,
    y1: 182.2571,
    x2: 73.6753,
    y2: 199.2411,
    id: "Stroke-342",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0577,
    y1: 180.265,
    x2: 73.6757,
    y2: 197.249,
    id: "Stroke-343",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0582,
    y1: 201.7278,
    x2: 73.6752,
    y2: 218.7128,
    id: "Stroke-344",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.1066,
    y1: 72.5975,
    x2: 173.3606,
    y2: 72.6945,
    id: "Stroke-345",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4425,
    y1: 198.7288,
    x2: 71.2225,
    y2: 199.1528,
    id: "Stroke-346",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.8331,
    y1: 254.928,
    x2: 79.3341,
    y2: 255.315,
    id: "Stroke-347",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.8331,
    y1: 250.9427,
    x2: 79.3341,
    y2: 251.3297,
    id: "Stroke-348",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.4161,
    y1: 250.1097,
    x2: 80.4901,
    y2: 249.6787,
    id: "Stroke-349",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7072,
    y1: 247.6693,
    x2: 79.3342,
    y2: 248.0273,
    id: "Stroke-350",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1349,
    y1: 245.0745,
    x2: 72.8789,
    y2: 245.3985,
    id: "Stroke-351",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.3522,
    y1: 243.0638,
    x2: 70.4262,
    y2: 243.4958,
    id: "Stroke-352",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1349,
    y1: 245.0394,
    x2: 72.1049,
    y2: 245.0574,
    id: "Stroke-353",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.1349,
    y1: 245.0394,
    x2: 72.1819,
    y2: 245.0184,
    id: "Stroke-354",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.5079,
    y1: 241.4134,
    x2: 71.0089,
    y2: 241.8014,
    id: "Stroke-355",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.5079,
    y1: 241.4134,
    x2: 72.1349,
    y2: 241.0544,
    id: "Stroke-356",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.382,
    y1: 275.2239,
    x2: 78.755,
    y2: 275.5829,
    id: "Stroke-357",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.755,
    y1: 271.598,
    x2: 78.011,
    y2: 271.922,
    id: "Stroke-358",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.8815,
    y1: 274.8372,
    x2: 79.3815,
    y2: 275.2242,
    id: "Stroke-359",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.2443,
    y1: 274.428,
    x2: 79.8813,
    y2: 274.837,
    id: "Stroke-360",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.8815,
    y1: 270.8509,
    x2: 79.3815,
    y2: 271.2389,
    id: "Stroke-361",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.464,
    y1: 274.0042,
    x2: 80.244,
    y2: 274.4282,
    id: "Stroke-362",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.2443,
    y1: 270.4417,
    x2: 79.8813,
    y2: 270.8507,
    id: "Stroke-363",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.5382,
    y1: 273.5735,
    x2: 80.4642,
    y2: 274.0045,
    id: "Stroke-364",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.5382,
    y1: 273.5735,
    x2: 80.5382,
    y2: 269.5885,
    id: "Stroke-365",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.464,
    y1: 270.0189,
    x2: 80.244,
    y2: 270.4419,
    id: "Stroke-366",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.464,
    y1: 270.0189,
    x2: 80.538,
    y2: 269.5879,
    id: "Stroke-367",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.0109,
    y1: 275.9075,
    x2: 78.7549,
    y2: 275.5835,
    id: "Stroke-368",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.0109,
    y1: 275.9075,
    x2: 23.4499,
    y2: 296.7875,
    id: "Stroke-369",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.4503,
    y1: 292.8021,
    x2: 23.4503,
    y2: 296.7871,
    id: "Stroke-370",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 207.053,
    x2: 80.6293,
    y2: 207.462,
    id: "Stroke-371",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7594,
    y1: 210.5257,
    x2: 61.5314,
    y2: 217.1187,
    id: "Stroke-372",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 210.2015,
    x2: 78.7591,
    y2: 210.5255,
    id: "Stroke-373",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 209.8421,
    x2: 79.5035,
    y2: 210.2011,
    id: "Stroke-374",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 209.4544,
    x2: 80.1305,
    y2: 209.8424,
    id: "Stroke-375",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 207.8489,
    x2: 79.5035,
    y2: 208.2079,
    id: "Stroke-376",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 209.0462,
    x2: 80.6293,
    y2: 209.4542,
    id: "Stroke-377",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 208.6224,
    x2: 80.9925,
    y2: 209.0464,
    id: "Stroke-378",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2863,
    y1: 208.1907,
    x2: 81.2123,
    y2: 208.6227,
    id: "Stroke-379",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2863,
    y1: 208.1907,
    x2: 81.2863,
    y2: 206.1987,
    id: "Stroke-380",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 206.6292,
    x2: 80.9925,
    y2: 207.0532,
    id: "Stroke-381",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 206.6292,
    x2: 81.2865,
    y2: 206.1982,
    id: "Stroke-382",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 205.7679,
    x2: 81.2865,
    y2: 206.1989,
    id: "Stroke-383",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 205.3441,
    x2: 81.2123,
    y2: 205.7681,
    id: "Stroke-384",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 201.9183,
    x2: 78.7594,
    y2: 203.8633,
    id: "Stroke-385",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9313,
    y1: 199.5667,
    x2: 72.3043,
    y2: 199.9247,
    id: "Stroke-386",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 199.2415,
    x2: 72.9314,
    y2: 199.5665,
    id: "Stroke-387",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 197.2493,
    x2: 72.9314,
    y2: 197.5733,
    id: "Stroke-388",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 200.3128,
    x2: 71.5683,
    y2: 200.5808,
    id: "Stroke-389",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 200.3128,
    x2: 72.3043,
    y2: 199.9248,
    id: "Stroke-390",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7594,
    y1: 208.5335,
    x2: 61.5314,
    y2: 215.1265,
    id: "Stroke-391",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 208.2083,
    x2: 78.7591,
    y2: 208.5333,
    id: "Stroke-392",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 207.4622,
    x2: 80.1305,
    y2: 207.8492,
    id: "Stroke-393",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 204.9349,
    x2: 80.9925,
    y2: 205.3439,
    id: "Stroke-394",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 204.5472,
    x2: 80.6295,
    y2: 204.9352,
    id: "Stroke-395",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.3043,
    y1: 201.2347,
    x2: 72.9313,
    y2: 201.5937,
    id: "Stroke-396",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 200.847,
    x2: 72.3043,
    y2: 201.235,
    id: "Stroke-397",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.2223,
    y1: 200.015,
    x2: 71.4423,
    y2: 200.439,
    id: "Stroke-398",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.1486,
    y1: 199.5833,
    x2: 71.2226,
    y2: 200.0153,
    id: "Stroke-399",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.2223,
    y1: 199.1527,
    x2: 71.1483,
    y2: 199.5837,
    id: "Stroke-400",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 198.3206,
    x2: 71.4423,
    y2: 198.7286,
    id: "Stroke-401",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.3043,
    y1: 197.9329,
    x2: 71.8053,
    y2: 198.3209,
    id: "Stroke-402",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9313,
    y1: 197.5736,
    x2: 72.3043,
    y2: 197.9326,
    id: "Stroke-403",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 201.9183,
    x2: 72.9314,
    y2: 201.5943,
    id: "Stroke-404",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 204.1888,
    x2: 80.1301,
    y2: 204.5468,
    id: "Stroke-405",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 204.1888,
    x2: 78.7591,
    y2: 203.8638,
    id: "Stroke-406",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7594,
    y1: 229.9964,
    x2: 61.5314,
    y2: 236.5904,
    id: "Stroke-407",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 229.6722,
    x2: 78.7591,
    y2: 229.9962,
    id: "Stroke-408",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 228.9261,
    x2: 80.1305,
    y2: 229.3131,
    id: "Stroke-409",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2863,
    y1: 227.6624,
    x2: 81.2123,
    y2: 228.0934,
    id: "Stroke-410",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 226.8079,
    x2: 81.2123,
    y2: 227.2309,
    id: "Stroke-411",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 226.3987,
    x2: 80.9925,
    y2: 226.8077,
    id: "Stroke-412",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 226.011,
    x2: 80.6295,
    y2: 226.399,
    id: "Stroke-413",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.3043,
    y1: 222.6986,
    x2: 72.9313,
    y2: 223.0566,
    id: "Stroke-414",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.2223,
    y1: 221.4778,
    x2: 71.4423,
    y2: 221.9018,
    id: "Stroke-415",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.3043,
    y1: 219.3968,
    x2: 71.8053,
    y2: 219.7848,
    id: "Stroke-416",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9313,
    y1: 219.0374,
    x2: 72.3043,
    y2: 219.3964,
    id: "Stroke-417",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 223.3821,
    x2: 72.9314,
    y2: 223.0571,
    id: "Stroke-418",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 225.6527,
    x2: 80.1301,
    y2: 226.0107,
    id: "Stroke-419",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 225.6527,
    x2: 78.7591,
    y2: 225.3277,
    id: "Stroke-420",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 143.4871,
    x2: 60.006,
    y2: 118.0661,
    id: "Stroke-421",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 159.4876,
    x2: 23.402,
    y2: 157.4946,
    id: "Stroke-422",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.006,
    y1: 143.4871,
    x2: 60.006,
    y2: 145.4801,
    id: "Stroke-423",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 185.3411,
    x2: 80.6293,
    y2: 185.7501,
    id: "Stroke-424",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.2155,
    y1: 198.7318,
    x2: 188.2155,
    y2: 174.8388,
    id: "Stroke-425",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.6032,
    y1: 101.4915,
    x2: 97.8572,
    y2: 101.5885,
    id: "Stroke-426",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.5324,
    y1: 243.9046,
    x2: 118.0584,
    y2: 222.2726,
    id: "Stroke-427",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.902,
    y1: 85.1214,
    x2: 192.664,
    y2: 78.3244,
    id: "Stroke-428",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0577,
    y1: 223.4407,
    x2: 72.8787,
    y2: 240.7297,
    id: "Stroke-429",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0582,
    y1: 160.5452,
    x2: 73.6752,
    y2: 177.5292,
    id: "Stroke-430",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0587,
    y1: 158.5521,
    x2: 73.6757,
    y2: 175.5371,
    id: "Stroke-431",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 275.1312,
    x2: 352.9486,
    y2: 200.8062,
    id: "Stroke-432",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.986,
    y1: 86.9974,
    x2: 135.732,
    y2: 86.8994,
    id: "Stroke-433",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.3761,
    y1: 268.9525,
    x2: 157.2031,
    y2: 276.5405,
    id: "Stroke-434",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.5328,
    y1: 141.575,
    x2: 348.5328,
    y2: 139.582,
    id: "Stroke-435",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.4361,
    y1: 152.0003,
    x2: 313.8241,
    y2: 152.2203,
    id: "Stroke-436",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.4361,
    y1: 153.993,
    x2: 313.8241,
    y2: 154.213,
    id: "Stroke-437",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.2447,
    y1: 151.6502,
    x2: 312.4357,
    y2: 152.0002,
    id: "Stroke-438",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.2447,
    y1: 153.6434,
    x2: 312.4357,
    y2: 153.9934,
    id: "Stroke-439",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 139.8694,
    x2: 348.533,
    y2: 139.5824,
    id: "Stroke-440",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3443,
    y1: 142.9149,
    x2: 346.8483,
    y2: 143.1309,
    id: "Stroke-441",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.8483,
    y1: 138.0257,
    x2: 347.3443,
    y2: 138.2427,
    id: "Stroke-442",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7623,
    y1: 138.4818,
    x2: 347.3443,
    y2: 138.2428,
    id: "Stroke-443",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.0953,
    y1: 138.7396,
    x2: 347.7623,
    y2: 138.4816,
    id: "Stroke-444",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.3365,
    y1: 139.0125,
    x2: 348.0955,
    y2: 138.7395,
    id: "Stroke-445",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 139.2947,
    x2: 348.337,
    y2: 139.0127,
    id: "Stroke-446",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 132.7728,
    x2: 346.8487,
    y2: 138.0258,
    id: "Stroke-447",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 141.8621,
    x2: 348.533,
    y2: 141.5751,
    id: "Stroke-448",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.3365,
    y1: 142.1448,
    x2: 348.4835,
    y2: 141.8618,
    id: "Stroke-449",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.0953,
    y1: 142.4173,
    x2: 348.3363,
    y2: 142.1453,
    id: "Stroke-450",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7623,
    y1: 142.6756,
    x2: 347.3443,
    y2: 142.9146,
    id: "Stroke-451",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.7623,
    y1: 142.6756,
    x2: 348.0953,
    y2: 142.4176,
    id: "Stroke-452",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3443,
    y1: 140.9222,
    x2: 347.7623,
    y2: 140.6832,
    id: "Stroke-453",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.3121,
    y1: 154.2879,
    x2: 313.8241,
    y2: 154.2129,
    id: "Stroke-454",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.8004,
    y1: 154.2127,
    x2: 315.3124,
    y2: 154.2877,
    id: "Stroke-455",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.3121,
    y1: 152.2952,
    x2: 313.8241,
    y2: 152.2202,
    id: "Stroke-456",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.1881,
    y1: 152.0003,
    x2: 319.3791,
    y2: 151.6503,
    id: "Stroke-457",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.1881,
    y1: 153.993,
    x2: 319.3791,
    y2: 153.643,
    id: "Stroke-458",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.1881,
    y1: 153.993,
    x2: 316.8001,
    y2: 154.213,
    id: "Stroke-459",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.8004,
    y1: 152.22,
    x2: 318.1884,
    y2: 152,
    id: "Stroke-460",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.5114,
    y1: 86.4134,
    x2: 135.9864,
    y2: 86.9974,
    id: "Stroke-461",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.8854,
    y1: 72.1107,
    x2: 173.3604,
    y2: 72.6947,
    id: "Stroke-462",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.8771,
    y1: 297.389,
    x2: 21.8611,
    y2: 297.383,
    id: "Stroke-463",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.1915,
    y1: 176.6722,
    x2: 49.1915,
    y2: 178.6652,
    id: "Stroke-464",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 163.327,
    x2: 333.1217,
    y2: 148.384,
    id: "Stroke-465",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 84.9129,
    x2: 23.402,
    y2: 82.9199,
    id: "Stroke-466",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.858,
    y1: 107.3821,
    x2: 74.533,
    y2: 110.9501,
    id: "Stroke-467",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.4899,
    y1: 10.9417,
    x2: 211.4899,
    y2: 12.9347,
    id: "Stroke-468",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.402,
    y1: 296.806,
    x2: 21.877,
    y2: 297.389,
    id: "Stroke-469",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.4137,
    y1: 127.4241,
    x2: 34.9567,
    y2: 127.6521,
    id: "Stroke-470",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7008,
    y1: 127.159,
    x2: 35.4138,
    y2: 127.424,
    id: "Stroke-471",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7985,
    y1: 126.8743,
    x2: 35.7005,
    y2: 127.1593,
    id: "Stroke-472",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.4132,
    y1: 122.4896,
    x2: 45.7202,
    y2: 122.3796,
    id: "Stroke-473",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.1578,
    y1: 122.5272,
    x2: 46.4128,
    y2: 122.4892,
    id: "Stroke-474",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.902,
    y1: 122.4896,
    x2: 47.158,
    y2: 122.5276,
    id: "Stroke-475",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5958,
    y1: 122.3797,
    x2: 47.9018,
    y2: 122.4897,
    id: "Stroke-476",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.1915,
    y1: 122.2049,
    x2: 48.5955,
    y2: 122.3799,
    id: "Stroke-477",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.1241,
    y1: 122.2049,
    x2: 45.7201,
    y2: 122.3799,
    id: "Stroke-478",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.1476,
    y1: 112.6014,
    x2: 73.6906,
    y2: 112.8294,
    id: "Stroke-479",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.4347,
    y1: 112.3358,
    x2: 74.1477,
    y2: 112.6018,
    id: "Stroke-480",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.6359,
    y1: 107.6668,
    x2: 85.8919,
    y2: 107.7048,
    id: "Stroke-481",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.3297,
    y1: 107.5565,
    x2: 86.6357,
    y2: 107.6665,
    id: "Stroke-482",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.2638,
    y1: 97.9949,
    x2: 111.1658,
    y2: 98.2799,
    id: "Stroke-483",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.8785,
    y1: 93.6102,
    x2: 121.1845,
    y2: 93.5002,
    id: "Stroke-484",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.6227,
    y1: 93.6478,
    x2: 121.8787,
    y2: 93.6098,
    id: "Stroke-485",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.3673,
    y1: 93.6102,
    x2: 122.6223,
    y2: 93.6482,
    id: "Stroke-486",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.0607,
    y1: 93.5003,
    x2: 123.3677,
    y2: 93.6103,
    id: "Stroke-487",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.5895,
    y1: 93.3255,
    x2: 111.2645,
    y2: 96.8935,
    id: "Stroke-488",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.5895,
    y1: 93.3255,
    x2: 121.1845,
    y2: 93.5005,
    id: "Stroke-489",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.6608,
    y1: 84.5218,
    x2: 124.6568,
    y2: 93.3258,
    id: "Stroke-490",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.1183,
    y1: 84.2943,
    x2: 147.6603,
    y2: 84.5223,
    id: "Stroke-491",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.4054,
    y1: 84.0286,
    x2: 148.1184,
    y2: 84.2946,
    id: "Stroke-492",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.1178,
    y1: 79.3597,
    x2: 158.4248,
    y2: 79.2497,
    id: "Stroke-493",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.8624,
    y1: 79.3968,
    x2: 159.1174,
    y2: 79.3598,
    id: "Stroke-494",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.6066,
    y1: 79.3597,
    x2: 159.8626,
    y2: 79.3967,
    id: "Stroke-495",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.8956,
    y1: 79.0745,
    x2: 161.3006,
    y2: 79.2495,
    id: "Stroke-496",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.5348,
    y1: 69.4373,
    x2: 186.2468,
    y2: 69.7033,
    id: "Stroke-497",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.2467,
    y1: 64.7679,
    x2: 196.5537,
    y2: 64.6579,
    id: "Stroke-498",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.736,
    y1: 64.7679,
    x2: 197.992,
    y2: 64.8059,
    id: "Stroke-499",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.4293,
    y1: 64.658,
    x2: 198.7363,
    y2: 64.768,
    id: "Stroke-500",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.025,
    y1: 64.4832,
    x2: 199.429,
    y2: 64.6582,
    id: "Stroke-501",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.9576,
    y1: 64.4832,
    x2: 196.5536,
    y2: 64.6582,
    id: "Stroke-502",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5958,
    y1: 178.8402,
    x2: 49.1918,
    y2: 178.6652,
    id: "Stroke-503",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0582,
    y1: 158.5364,
    x2: 100.1682,
    y2: 165.3824,
    id: "Stroke-504",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.4137,
    y1: 183.8851,
    x2: 34.9567,
    y2: 184.1131,
    id: "Stroke-505",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.4132,
    y1: 178.9505,
    x2: 45.7202,
    y2: 178.8405,
    id: "Stroke-506",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.1578,
    y1: 178.9876,
    x2: 46.4128,
    y2: 178.9506,
    id: "Stroke-507",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.902,
    y1: 178.9505,
    x2: 47.158,
    y2: 178.9875,
    id: "Stroke-508",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.1686,
    y1: 165.3826,
    x2: 98.9776,
    y2: 165.7326,
    id: "Stroke-509",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.8434,
    y1: 165.033,
    x2: 92.0344,
    y2: 165.383,
    id: "Stroke-510",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.8434,
    y1: 161.0472,
    x2: 92.0344,
    y2: 161.3972,
    id: "Stroke-511",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.4562,
    y1: 164.8128,
    x2: 90.8432,
    y2: 165.0328,
    id: "Stroke-512",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.4562,
    y1: 160.8275,
    x2: 90.8432,
    y2: 161.0475,
    id: "Stroke-513",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9674,
    y1: 164.7381,
    x2: 89.4564,
    y2: 164.8131,
    id: "Stroke-514",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.9674,
    y1: 160.7527,
    x2: 89.4564,
    y2: 160.8277,
    id: "Stroke-515",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.4786,
    y1: 164.8128,
    x2: 87.9676,
    y2: 164.7378,
    id: "Stroke-516",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.4786,
    y1: 160.8275,
    x2: 87.9676,
    y2: 160.7525,
    id: "Stroke-517",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.4786,
    y1: 160.8275,
    x2: 85.0916,
    y2: 161.0475,
    id: "Stroke-518",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.0914,
    y1: 165.033,
    x2: 86.4784,
    y2: 164.813,
    id: "Stroke-519",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8029,
    y1: 212.7064,
    x2: 152.6119,
    y2: 212.3564,
    id: "Stroke-520",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.6788,
    y1: 213.0013,
    x2: 155.1898,
    y2: 212.9263,
    id: "Stroke-521",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5548,
    y1: 212.7064,
    x2: 158.1678,
    y2: 212.9264,
    id: "Stroke-522",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.7462,
    y1: 212.3568,
    x2: 159.5552,
    y2: 212.7068,
    id: "Stroke-523",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.7115,
    y1: 201.6282,
    x2: 188.2155,
    y2: 201.8452,
    id: "Stroke-524",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 201.389,
    x2: 188.7115,
    y2: 201.628,
    id: "Stroke-525",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.8502,
    y1: 200.5755,
    x2: 189.7042,
    y2: 200.8575,
    id: "Stroke-526",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.9,
    y1: 200.2884,
    x2: 189.85,
    y2: 200.5754,
    id: "Stroke-527",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.8502,
    y1: 200.0013,
    x2: 189.9002,
    y2: 200.2883,
    id: "Stroke-528",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.7037,
    y1: 199.7191,
    x2: 189.8497,
    y2: 200.0011,
    id: "Stroke-529",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.4615,
    y1: 199.4456,
    x2: 189.7035,
    y2: 199.7186,
    id: "Stroke-530",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.1285,
    y1: 199.1878,
    x2: 189.4615,
    y2: 199.4458,
    id: "Stroke-531",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.2155,
    y1: 198.7318,
    x2: 188.7115,
    y2: 198.9488,
    id: "Stroke-532",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.8238,
    y1: 182.7757,
    x2: 312.4358,
    y2: 182.5547,
    id: "Stroke-533",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.3121,
    y1: 182.8499,
    x2: 313.8241,
    y2: 182.7759,
    id: "Stroke-534",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.3365,
    y1: 170.7069,
    x2: 348.0955,
    y2: 170.9789,
    id: "Stroke-535",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.484,
    y1: 169.8499,
    x2: 348.533,
    y2: 170.1369,
    id: "Stroke-536",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.0953,
    y1: 169.2947,
    x2: 348.3363,
    y2: 169.5677,
    id: "Stroke-537",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 163.3279,
    x2: 311.2457,
    y2: 171.6999,
    id: "Stroke-538",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3443,
    y1: 168.7972,
    x2: 347.7623,
    y2: 169.0362,
    id: "Stroke-539",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.3443,
    y1: 168.7972,
    x2: 346.8483,
    y2: 168.5812,
    id: "Stroke-540",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 193.2191,
    x2: 333.1217,
    y2: 178.9391,
    id: "Stroke-541",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 193.2191,
    x2: 352.9487,
    y2: 200.8061,
    id: "Stroke-542",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.9899,
    y1: 116.0794,
    x2: 59.7369,
    y2: 115.9824,
    id: "Stroke-543",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.1217,
    y1: 193.2191,
    x2: 311.2447,
    y2: 201.5911,
    id: "Stroke-544",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9488,
    y1: 202.7991,
    x2: 352.9488,
    y2: 200.8061,
    id: "Stroke-545",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.7286,
    y1: 277.1243,
    x2: 157.2036,
    y2: 276.5403,
    id: "Stroke-546",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.2032,
    y1: 350.2708,
    x2: 158.7282,
    y2: 350.8548,
    id: "Stroke-547",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.9488,
    y1: 264.5735,
    x2: 352.9488,
    y2: 276.5295,
    id: "Stroke-549",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.2032,
    y1: 276.5403,
    x2: 157.2032,
    y2: 350.2703,
    id: "Stroke-550",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.0573,
    y1: 335.2903,
    x2: 157.2033,
    y2: 350.2703,
    id: "Stroke-551",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7594,
    y1: 231.9896,
    x2: 61.5314,
    y2: 238.5826,
    id: "Stroke-553",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 231.6644,
    x2: 78.7591,
    y2: 231.9894,
    id: "Stroke-554",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 231.306,
    x2: 79.5035,
    y2: 231.664,
    id: "Stroke-555",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 230.9183,
    x2: 80.1305,
    y2: 231.3063,
    id: "Stroke-556",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 229.3128,
    x2: 79.5035,
    y2: 229.6718,
    id: "Stroke-557",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 230.5091,
    x2: 80.6293,
    y2: 230.9181,
    id: "Stroke-558",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 230.0862,
    x2: 80.9925,
    y2: 230.5092,
    id: "Stroke-559",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2863,
    y1: 229.6546,
    x2: 81.2123,
    y2: 230.0866,
    id: "Stroke-560",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2863,
    y1: 229.6546,
    x2: 81.2863,
    y2: 227.6626,
    id: "Stroke-561",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 228.0931,
    x2: 80.9925,
    y2: 228.5171,
    id: "Stroke-562",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 227.2308,
    x2: 81.2865,
    y2: 227.6628,
    id: "Stroke-563",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 223.3821,
    x2: 78.7594,
    y2: 225.3271,
    id: "Stroke-564",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 222.3109,
    x2: 72.3043,
    y2: 222.6989,
    id: "Stroke-565",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.1486,
    y1: 221.0472,
    x2: 71.2226,
    y2: 221.4782,
    id: "Stroke-566",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.2223,
    y1: 220.6165,
    x2: 71.1483,
    y2: 221.0475,
    id: "Stroke-567",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9313,
    y1: 221.0306,
    x2: 72.3043,
    y2: 221.3886,
    id: "Stroke-568",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 220.7054,
    x2: 72.9314,
    y2: 221.0304,
    id: "Stroke-569",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 218.7132,
    x2: 72.9314,
    y2: 219.0372,
    id: "Stroke-570",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 221.7767,
    x2: 71.5683,
    y2: 222.0437,
    id: "Stroke-571",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 221.7767,
    x2: 72.3043,
    y2: 221.3887,
    id: "Stroke-572",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.4425,
    y1: 220.1927,
    x2: 71.8055,
    y2: 219.7847,
    id: "Stroke-573",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7008,
    y1: 183.6194,
    x2: 35.7988,
    y2: 183.3344,
    id: "Stroke-574",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.4137,
    y1: 225.0677,
    x2: 34.9567,
    y2: 225.2957,
    id: "Stroke-575",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5958,
    y1: 220.0228,
    x2: 47.9648,
    y2: 220.1238,
    id: "Stroke-576",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.1915,
    y1: 219.848,
    x2: 48.5955,
    y2: 220.023,
    id: "Stroke-577",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.3859,
    y1: 231.7161,
    x2: 23.3859,
    y2: 229.7231,
    id: "Stroke-578",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.4137,
    y1: 227.0609,
    x2: 34.9567,
    y2: 227.2889,
    id: "Stroke-579",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7985,
    y1: 226.5101,
    x2: 35.7005,
    y2: 226.7951,
    id: "Stroke-580",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.4132,
    y1: 222.1253,
    x2: 45.7202,
    y2: 222.0163,
    id: "Stroke-581",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.1578,
    y1: 222.1634,
    x2: 46.4128,
    y2: 222.1254,
    id: "Stroke-582",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.902,
    y1: 222.1253,
    x2: 47.158,
    y2: 222.1633,
    id: "Stroke-583",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.1915,
    y1: 221.8411,
    x2: 48.5955,
    y2: 222.0161,
    id: "Stroke-584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.8029,
    y1: 214.6995,
    x2: 152.6119,
    y2: 214.3485,
    id: "Stroke-585",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.1676,
    y1: 214.9193,
    x2: 156.6786,
    y2: 214.9943,
    id: "Stroke-586",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.5548,
    y1: 214.6995,
    x2: 158.1678,
    y2: 214.9195,
    id: "Stroke-587",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.4615,
    y1: 203.1234,
    x2: 189.1285,
    y2: 203.3824,
    id: "Stroke-588",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.7037,
    y1: 202.8509,
    x2: 189.4617,
    y2: 203.1229,
    id: "Stroke-589",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.8502,
    y1: 202.5687,
    x2: 189.7042,
    y2: 202.8507,
    id: "Stroke-590",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.0109,
    y1: 255.9808,
    x2: 77.9629,
    y2: 255.9998,
    id: "Stroke-591",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.5153,
    y1: 115.4959,
    x2: 59.9903,
    y2: 116.0789,
    id: "Stroke-592",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.3824,
    y1: 101.0047,
    x2: 97.8574,
    y2: 101.5887,
    id: "Stroke-593",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.1954,
    y1: 136.2889,
    x2: 23.4024,
    y2: 143.0979,
    id: "Stroke-594",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.0109,
    y1: 271.9222,
    x2: 23.4499,
    y2: 292.8022,
    id: "Stroke-595",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.382,
    y1: 255.2972,
    x2: 78.755,
    y2: 255.6552,
    id: "Stroke-596",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.8815,
    y1: 254.9095,
    x2: 79.3815,
    y2: 255.2975,
    id: "Stroke-597",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.464,
    y1: 254.0765,
    x2: 80.538,
    y2: 253.6455,
    id: "Stroke-598",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7072,
    y1: 251.6888,
    x2: 77.9632,
    y2: 252.0128,
    id: "Stroke-599",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1959,
    y1: 250.5335,
    x2: 79.8329,
    y2: 250.9425,
    id: "Stroke-600",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.4161,
    y1: 250.1097,
    x2: 80.1961,
    y2: 250.5337,
    id: "Stroke-601",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.4161,
    y1: 249.2484,
    x2: 80.4901,
    y2: 249.6794,
    id: "Stroke-602",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1959,
    y1: 248.8245,
    x2: 80.4159,
    y2: 249.2485,
    id: "Stroke-603",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.8331,
    y1: 248.4153,
    x2: 80.1961,
    y2: 248.8243,
    id: "Stroke-604",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.3341,
    y1: 248.0277,
    x2: 79.8331,
    y2: 248.4157,
    id: "Stroke-605",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.0089,
    y1: 244.3275,
    x2: 71.5079,
    y2: 244.7155,
    id: "Stroke-606",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.4259,
    y1: 243.4954,
    x2: 70.6459,
    y2: 243.9184,
    id: "Stroke-607",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.4259,
    y1: 242.6331,
    x2: 70.3519,
    y2: 243.0641,
    id: "Stroke-608",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.6461,
    y1: 242.2093,
    x2: 70.4261,
    y2: 242.6333,
    id: "Stroke-609",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.0089,
    y1: 241.8011,
    x2: 70.6459,
    y2: 242.2091,
    id: "Stroke-610",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.879,
    y1: 240.7298,
    x2: 72.135,
    y2: 241.0538,
    id: "Stroke-611",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.879,
    y1: 245.3987,
    x2: 77.963,
    y2: 247.3437,
    id: "Stroke-612",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7072,
    y1: 247.6693,
    x2: 77.9632,
    y2: 247.3443,
    id: "Stroke-613",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.3341,
    y1: 255.3148,
    x2: 78.7071,
    y2: 255.6738,
    id: "Stroke-614",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1959,
    y1: 254.5189,
    x2: 79.8329,
    y2: 254.9279,
    id: "Stroke-615",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.4161,
    y1: 254.095,
    x2: 80.1961,
    y2: 254.519,
    id: "Stroke-616",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.4899,
    y1: 253.6644,
    x2: 80.4159,
    y2: 254.0954,
    id: "Stroke-617",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7594,
    y1: 188.8138,
    x2: 61.5314,
    y2: 195.4068,
    id: "Stroke-618",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 188.4896,
    x2: 78.7591,
    y2: 188.8136,
    id: "Stroke-619",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7594,
    y1: 186.8216,
    x2: 61.5314,
    y2: 193.4146,
    id: "Stroke-620",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 188.1302,
    x2: 79.5035,
    y2: 188.4892,
    id: "Stroke-621",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 186.4964,
    x2: 78.7591,
    y2: 186.8214,
    id: "Stroke-622",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 187.7425,
    x2: 80.1305,
    y2: 188.1305,
    id: "Stroke-623",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 186.137,
    x2: 79.5035,
    y2: 186.496,
    id: "Stroke-624",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 187.3343,
    x2: 80.6293,
    y2: 187.7423,
    id: "Stroke-625",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 185.7503,
    x2: 80.1305,
    y2: 186.1373,
    id: "Stroke-626",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 186.9105,
    x2: 80.9925,
    y2: 187.3345,
    id: "Stroke-627",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2863,
    y1: 186.4788,
    x2: 81.2123,
    y2: 186.9108,
    id: "Stroke-628",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2863,
    y1: 186.4788,
    x2: 81.2863,
    y2: 184.4868,
    id: "Stroke-629",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 184.9173,
    x2: 80.9925,
    y2: 185.3413,
    id: "Stroke-630",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 184.9173,
    x2: 81.2865,
    y2: 184.4863,
    id: "Stroke-631",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.2125,
    y1: 184.055,
    x2: 81.2865,
    y2: 184.487,
    id: "Stroke-632",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.9923,
    y1: 183.6321,
    x2: 81.2123,
    y2: 184.0551,
    id: "Stroke-633",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6295,
    y1: 183.223,
    x2: 80.9925,
    y2: 183.632,
    id: "Stroke-634",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1305,
    y1: 182.8353,
    x2: 80.6295,
    y2: 183.2233,
    id: "Stroke-635",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.5031,
    y1: 182.4769,
    x2: 80.1301,
    y2: 182.8349,
    id: "Stroke-636",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.7594,
    y1: 182.1517,
    x2: 79.5034,
    y2: 182.4767,
    id: "Stroke-637",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 180.2064,
    x2: 78.7594,
    y2: 182.1514,
    id: "Stroke-638",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9313,
    y1: 179.8821,
    x2: 73.6753,
    y2: 180.2061,
    id: "Stroke-639",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.3043,
    y1: 179.5228,
    x2: 72.9313,
    y2: 179.8818,
    id: "Stroke-640",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 179.1351,
    x2: 72.3043,
    y2: 179.5231,
    id: "Stroke-641",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.2223,
    y1: 178.303,
    x2: 71.4423,
    y2: 178.727,
    id: "Stroke-642",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.1486,
    y1: 177.8714,
    x2: 71.2226,
    y2: 178.3034,
    id: "Stroke-643",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.2223,
    y1: 177.4407,
    x2: 71.1483,
    y2: 177.8717,
    id: "Stroke-644",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9313,
    y1: 177.8548,
    x2: 72.3043,
    y2: 178.2128,
    id: "Stroke-645",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.3043,
    y1: 176.221,
    x2: 71.8053,
    y2: 176.609,
    id: "Stroke-646",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 177.5296,
    x2: 72.9314,
    y2: 177.8546,
    id: "Stroke-647",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.9313,
    y1: 175.8616,
    x2: 72.3043,
    y2: 176.2206,
    id: "Stroke-648",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6754,
    y1: 175.5374,
    x2: 72.9314,
    y2: 175.8614,
    id: "Stroke-649",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 178.6009,
    x2: 71.5683,
    y2: 178.8679,
    id: "Stroke-650",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.8053,
    y1: 178.6009,
    x2: 72.3043,
    y2: 178.2129,
    id: "Stroke-651",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.5407,
    y1: 7.782,
    x2: 214.5407,
    y2: 82.511,
    id: "Stroke-652",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-667",
    transform: "translate(122.750200, 211.104800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8276,3.5957 L1.2246,0.2637 C0.8586,0.2637 0.5616,0.5607 0.5616,0.9257 L0.5616,9.5297 C0.5616,9.8957 0.8586,10.1927 1.2246,10.1927 L9.8276,13.5247 C10.1936,13.5247 10.4906,13.2277 10.4906,12.8617 L10.4906,4.2577 C10.4906,3.8927 10.1936,3.5957 9.8276,3.5957 Z",
    id: "Stroke-655",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.4062,
    y1: 6.1592,
    x2: 10.3432,
    y2: 3.9232,
    id: "Stroke-657",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.7089,
    y1: 9.9922,
    x2: 3.0679,
    y2: 7.6192,
    id: "Stroke-659",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.3681,
    y1: 8.4668,
    x2: 10.1601,
    y2: 13.3908,
    id: "Stroke-661",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.7968,
    y1: 0.3975,
    x2: 3.1048,
    y2: 5.3255,
    id: "Stroke-663",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2792,6.0967 L3.1992,5.2907 C3.1112,5.2907 3.0392,5.3637 3.0392,5.4507 L3.0392,7.5317 C3.0392,7.6187 3.1112,7.6917 3.1992,7.6917 L5.2792,8.4957 C5.3672,8.4957 5.4392,8.4247 5.4392,8.3357 L5.4392,6.2567 C5.4392,6.1677 5.3672,6.0967 5.2792,6.0967 Z",
    id: "Stroke-665",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketOffice);
export default __webpack_public_path__ + "static/media/pocket_office.97adef3e99a18bda9da6066c5a8c4463.svg";
export { ForwardRef as ReactComponent };